import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import util from 'util';
import Common from '../Common/common';
import { generatePath } from 'react-router';
import constClass from '../../Constants/Constants'

const BackyardNavBar = (props) => {
  const { user, userActions, settings, conditionActions } = props;
  const history = useHistory();
  const location = useLocation();

  const basePath = generatePath(`${props.match.path}`, { siteId: props.match.params.siteId });

  const isOnNavPage = (
    location.pathname.startsWith(`${basePath}qrcodescanner`)
  );

  const handleTitleClick = () => {
    userActions.refresh();
    history.replace(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}`);
  }

  const handleLogoutClick = () => {
    localStorage.removeItem('jwt');
    userActions.logout();
    conditionActions.logout();
    history.replace(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}/login`);
  }

  return (
    !isOnNavPage &&
    <nav className="navbar navbar-light navbar-expand-lg  bg-light fixed-top">
      <Link className="navbar-brand" onClick={handleTitleClick} to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}`}>
        {settings && settings.TITLE_SHORT_NAME ? settings.TITLE_SHORT_NAME : '予約'}<div className='d-none'>{util.inspect(history)}</div>
      </Link>
      {
        user.isLoggedIn &&
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      }
      {
        user.isLoggedIn &&
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <React.Fragment>
              <li className="nav-item">
                <Link className="nav-link" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}calendar`}>カレンダーマスタ</Link>
              </li>
            </React.Fragment>
            <li className="nav-item">
              <Link className="nav-link" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}BookingInput`}>予約入力</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}bookinglist`}>予約一覧</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}bookingcategory`}>受付QR表示</Link>
            </li>
            {Common.getSettingValue(settings, 'BOOKING_QR_READ', '0') === constClass.FLAG.ON &&
              <li className="nav-item">
                <Link className="nav-link" target="_blank" rel="noreferrer" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}qrcodescanner`}>QR読み取り</Link>
              </li>
            }
            {user.userClass === constClass.CLASS.ADMIN &&
              <React.Fragment>
                <li className="nav-item dropdown">
                  <button className="nav-link nav-btn dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    システム管理
                  </button>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <Link className="dropdown-item" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}user`}>ユーザマスタ</Link>
                    <Link className="dropdown-item" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}bookingcsv`}>予約CSVダウンロード</Link>
                  </div>
                </li>
              </React.Fragment>
            }
          </ul>
        </div>
      }
      {
        user.isLoggedIn &&
        <div>
          <label className="mr-2 text-primary">{user.userName}</label>
          <button className="btn btn-dark" onClick={handleLogoutClick}>ログアウト</button>
        </div>
      }
    </nav>
  );
}

export default BackyardNavBar;